import { combineReducers } from 'redux';
import loadingStatReducerFactory from '@nhl/loading-state-reducer-factory';
import actionTypes from './actionTypes';

const statsLoadingStateReducer = loadingStatReducerFactory(actionTypes.REQUEST_REPORT_DATA)(actionTypes.REPORT_DATA_RESPONSE);
const countryLoadingStateReducer = loadingStatReducerFactory(actionTypes.REQUEST_COUNTRY)(actionTypes.COUNTRY_RESPONSE);
const franchiseLoadingStateReducer = loadingStatReducerFactory(actionTypes.REQUEST_FRANCHISE)(actionTypes.FRANCHISE_RESPONSE);

const reportsDataReducer = (state = {}, action) => {
    const { payload } = action;

    if (action.type === actionTypes.REPORT_DATA_RESPONSE && !action.payload.errors) {
        const { reportData } = payload;
        const reportCategory = Object.keys(reportData)[0];
        const reportType = Object.keys(reportData[reportCategory])[0];

        const currentReportCategoryData = state[reportCategory];
        const newReportCategoryData = Object.assign({}, currentReportCategoryData, {[reportType]: reportData[reportCategory][reportType]});

        return Object.assign({}, state, {[reportCategory]: newReportCategoryData});
    }

    return state;
};

const countryReducer = (state = [], action) => {
    const { payload } = action;

    if (action.type === actionTypes.COUNTRY_RESPONSE) {
        return payload.countries;
    }

    return state;
};

const franchiseReducer = (state = [], action) => {
    const { payload } = action;

    if (action.type === actionTypes.FRANCHISE_RESPONSE) {
        return payload.franchises;
    }

    return state;
}

const statsReportsStateReducer = combineReducers({
    reportsData: reportsDataReducer,
    countries: countryReducer,
    franchises: franchiseReducer,
});

const reducer = combineReducers({
    countryLoadingState: countryLoadingStateReducer,
    statsLoadingState: statsLoadingStateReducer,
    franchiseLoadingState: franchiseLoadingStateReducer,
    statsReportsState: statsReportsStateReducer
});

export default reducer;
